// extracted by mini-css-extract-plugin
export default {"mainTr":"PollViewTableRow_mainTr__7pmVn","mainTd":"PollViewTableRow_mainTd__qJei9","hoverRow":"PollViewTableRow_hoverRow__6F8Ai","inactiveTd":"PollViewTableRow_inactiveTd__b9tJW"};